module.exports = __webpack_public_path__ + "static/riggs-website-77f9a96b42dfdf3c07c9024492138e0f.jpg";